import { ProductPublicModels } from '@features/products/product';
import { DuttiDate } from '@frontend/common/duttidate';

export interface ProductMapPrices {
    price: ProductPricesDetail;
    oldPrice: ProductPricesDetail;
    originalPrice?: ProductPricesDetail;
    lastReducedPrice?: ProductPricesDetail;
    oldVipPrice?: ProductPricesDetail; // TODO ECOMDUTI-26776: Deprecar precios VIP Fase 2 (Eliminar del modelo)
    vipPrice?: ProductPricesDetail; // TODO ECOMDUTI-26776: Deprecar precios VIP Fase 2 (Eliminar del modelo)
    unitPrice?: UnitPrice;
    percent?: PricePercent;
}

export interface ProductPricesDetail {
    value: number;
    type: PricesType;
}
export interface PricePercent {
    value: number;
    placePrice: boolean;
    showDisclaimer: boolean;
}

export enum PricesType {
    ORIGINALPRICE = 'ORIGINALPRICE',
    PRICE = 'PRICE',
    OLDPRICE = 'OLDPRICE',
    FUTUREPRICE = 'FUTUREPRICE',
    VIPPRICE = 'VIPPRICE', // TODO ECOMDUTI-26776: Deprecar precios VIP Fase 2 (Eliminar del modelo)
    OLDVIPPRICE = 'OLDVIPPRICE', // TODO ECOMDUTI-26776: Deprecar precios VIP Fase 2 (Eliminar del modelo)
}

export interface UnitPrice {
    price: number;
    type: string;
    unit: string;
}

export enum SalesPeriod {
    DEFAULT = 'DEFAULT',
    PREWARM = 'PREWARM',
    VEA = 'VEA',
    SALES = 'SALES',
}
export interface FromToDates {
    from: DuttiDate;
    to: DuttiDate;
}

export interface Discount {
    cta: boolean;
    key: string;
    class: string;
    promotionInfo: boolean;
}

export enum PercentatgeType {
    ROUND_1 = '1',
    ROUND_5 = '5',
}

export const ClassPrice = {
    throughPriceBlack: 'is-through',
    throughPrice: 'c-dark-grey c-gray is-through',
    link: 'link-line',
    primary: 'primary',
    textPromotion: 'c-sale text-l',
    textPromotionFeel: 'c-feel-dark text-l',
    textPromotionNwl: 'c-sale text-l',
    primarySales: 'c-sale',
    primaryNwl: 'c-sale',
    primaryFeel: 'c-feel-dark',
    sizeSB: 'text-l',
    sizeMB: 'text-m',
    sizeS: 'text-m',
    sizeM: 'text-m',
    sizeL: 'text-l',
};

export interface PricesClasses {
    container?: string;
    primaryPrice: string;
    secondaryPrice?: string;
    terciaryPrice?: string;
    lastReducedPrice?: string;
    alternativeCurrencies?: string;

    titleLarge?: boolean;
    marginPrice?: string;
}

export interface PriceStyles {
    backgroundColor: string; // Forzar color de fondo
    textColor: string; // Forzar color de texto
}

export interface CmsPriceStylesDetail {
    background_color: string;
    text_color: string;
}

export interface CmsPriceStyles {
    base: CmsPriceStylesDetail;
    event: CmsPriceStylesDetail;
}

export enum PriceRoundingType {
    ORIGINAL = 'original', // (precio de temporada OriginalPrice)
    CUT = 'cut', // (último precio rebajado OldPrice)
}

export class PriceDetail implements ProductPricesDetail {
    public type: PricesType;

    public value: number = null;

    constructor(name: string, productPrice: ProductPublicModels.PublicProductPrice) {
        if (!PricesType[name.toUpperCase()]) {
            throw new Error('Error Price type has not been defined');
        // biome-ignore lint/style/noUselessElse: <explanation>
        } else {
            this.type = PricesType[name.toUpperCase()];
            this.value = productPrice[name] || null;
        }
    }

    public reset() {
        this.value = null;
    }

    public isEqual(otherPrice: number): boolean {
        return !!otherPrice && this.value === otherPrice;
    }

    public hasType(type: PricesType): boolean {
        return this.type === type;
    }
}

export interface PrewarmConfig {
    today: { from: string; to: string };
    tomorrow: { from: string; to: string };
}

export interface PTCConfig {
    from: string;
    to: string;
}
export interface PrewarmDates {
    today: FromToDates;
    tomorrow: FromToDates;
}

export interface VipSalesDateRange {
    from: string;
    to: string;
}

export interface FormattedPriceOptions {
    showAlternateCurrencies?: boolean;
    noBreakPrice?: boolean;
    pricesInTwoColumns?: boolean;
}

export interface FormattedPriceStyles {
    primaryPrice: Record<string, any>;
    secondaryPrice?: Record<string, any>;
    alternativeCurrencies?: Record<string, any>;
    cmsStyles: PriceStyles;
}
